import * as React from 'react'

interface OutEggParams {
  doRotateBy180Deg?: boolean
  colors: string[]
}

const EasterEggSvgOut = ({ doRotateBy180Deg = false, colors }: OutEggParams): React.ReactElement => (
  <svg viewBox="0 0 64 64" width="32" height="32" transform={doRotateBy180Deg ? 'rotate(180)' : undefined}>
    <title>{'Easter Egg'}</title>
    <g style={{ isolation: 'isolate' }}>
      <g id="Layer_1">
        <path d="M16 36c0-15 7.2-26 16-26s16 11 16 26c0 11-7.2 20-16 20S16 47 16 36Z" fill={colors[0]} />
        <path d="M17 28c4-1 10-1.5 15-1.5s11 .5 15 1.5v7c-4 1-10 1.5-15 1.5s-11-.5-15-1.5Z" fill={colors[1]} opacity="0.85" />
        <path d="M18 22c2.5 3 5 3 7.5 0s5-3 7.5 0 5 3 7.5 0 5-3 5-3" fill="none" stroke={colors[2]} strokeWidth="2.5" strokeLinecap="round" />
        <g fill="#fff" opacity="0.9">
          <polygon points="24,31 25,33 27,33 25.5,34.5 26,36.5 24,35.2 22,36.5 22.5,34.5 21,33 23,33" />
          <polygon points="32,30 33,32 35,32 33.5,33.5 34,35.5 32,34.2 30,35.5 30.5,33.5 29,32 31,32" />
          <polygon points="40,31 41,33 43,33 41.5,34.5 42,36.5 40,35.2 38,36.5 38.5,34.5 37,33 39,33" />
        </g>
        <path d="M18.5 42c2.5 3 5 3 7.5 0s5-3 7.5 0 5 3 7.5 0 4-2 4-2" fill="none" stroke={colors[3]} strokeWidth="2.5" strokeLinecap="round" />
        <circle cx="25" cy="48" r="1.8" fill={colors[4]} />
        <circle cx="32" cy="49" r="1.8" fill={colors[3]} />
        <circle cx="39" cy="48" r="1.8" fill={colors[4]} />
        <path
          d="M16 36c0-15 7.2-26 16-26s16 11 16 26c0 11-7.2 20-16 20S16 47 16 36Z"
          fill="none"
          stroke="#000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M24 18c-2 3-3.5 7.5-3.5 12" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" opacity="0.5" />
      </g>
    </g>
  </svg>
)

export default EasterEggSvgOut
